import React, { useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { debounce, isNumber, sumBy } from 'lodash';
import {
    CheckBoxFields,
    DateField,
    TextField,
    TextAreaField,
    RadioBoxFields,
    FieldLabel
} from '../../forms/js/global';
import {
    TimeCaptureField,
    RadioCustomIconLabelFields,
    TypeRadioBoxFields,
} from './formquestions';
import { WorkExperienceContext } from './context';
import { emptyData, formQuestions } from './data';

export const AddEditWorkExperience = ({item, itemIndex, submitForm, showRemoveButton}) => {
    const [itemInfo, setItemInfo] = useState(item || emptyData);
    const [showFormErrors, setShowFormErrors] = useState([]);
    const [formSubmitted, setFormSubmitted] = useState();

    const formErrors = useMemo(() => checkRequiredFields(itemInfo), [itemInfo, showFormErrors]);

    const changeFormInfo = (dateName, newDate)=> {
        const newData = {...itemInfo, [dateName]: newDate}
        debounceSetInfo(newData);
    }

    const debounceSetInfo = debounce((newData) => {
        setItemInfo(newData);
    }, 300);

    const handleSubmit = (e, action) => {
        e.preventDefault();
        setShowFormErrors(formErrors);
        if(formErrors.length === 0) {
            let formAction = action;
            setFormSubmitted(true);
            if(action === '') {
                formAction = itemIndex === null ? 'add' : 'update';
            }
            const data = { id: itemInfo.id, data: itemInfo, type: formAction };

            submitForm(data);
        }
    }

    return (
        <>
            <div className="add-edit__header">
                <h2 className="add-edit__heading">
                    {item ? "Edit" : "Add new "} work experience
                </h2>
            </div>  
        
            <form className="add-edit__form" tabIndex="0" onSubmit={handleSubmit} >


                <PrintQuestions itemInfo={itemInfo} onChangeEvent={changeFormInfo} errors={showFormErrors} />

                <div className="add-edit__form-cta form__submit">
                    <button 
                        type="submit" 
                        className="button--submit add-edit__form-submit" 
                        onClick={(e) => handleSubmit(e, '')}
                        disabled={formSubmitted ? true : false}
                    >
                        {item ? "Finish editing" : "Add experience"}
                    </button>
                    {item ? <button 
                        type="button" 
                        className="button--submit add-edit__form-remove" 
                        onClick={showRemoveButton}
                        >
                        Remove work experience
                    </button> : null}
                </div>
            </form>
        </>
    )
}

const checkRequiredFields = (formAnswers) => {
    const requiredFieldArr = [];
    formQuestions.forEach((fieldGroup) => {
        fieldGroup.fields.forEach((field) => {
            const fieldName = field.name.toString();
            if(field.required) return requiredFieldArr.push(fieldName);
        })
    })

    const missingFields = requiredFieldArr.filter((field) => {
        let fieldAnswer = formAnswers[field];
        if(Array.isArray(fieldAnswer)) fieldAnswer.join();
        if(!isNumber(fieldAnswer)) {
            fieldAnswer = parseInt(fieldAnswer.length);
        }

        return fieldAnswer === 0
    });

    return missingFields;
}

const PrintQuestions = ({itemInfo, onChangeEvent, errors}) => {
    const { state } = useContext(WorkExperienceContext);
    const wowData = state[1];

    const paidEmp = wowData.length ? wowData.filter((item) => item.expType[0] === 'Paid employment') : [];
    const paidEmpUsed = sumBy(paidEmp, 'hoursCompleted');

    const allQuestions = formQuestions.map((fieldGroup, gi) => {
        const {fields, additionalClass} = fieldGroup;
        
        const groupQuestionFields = fields.map((question, qi) => {
            
            const fieldProps = {
                ...question, 
                value: itemInfo[question.name],
                selectedOptions: itemInfo[question.name],
                onChangeEvent, 
                error: errors.includes(question.name)
            };

            const questionClass = fieldProps.additionalQuestionClass || '';

            let printQuestion;
            // console.log(fieldProps);
            switch(fieldProps.type) {
                case 'checkbox': {
                    printQuestion = <CheckBoxFields {...fieldProps} />;
                }
                break;

                case 'date': {
                    printQuestion = <DateField {...fieldProps} />;
                }
                break;

                case 'text': {
                    printQuestion = <TextField {...fieldProps} />;
                }
                break;

                case 'textarea': {
                    printQuestion = <TextAreaField {...fieldProps} />
                }
                break;

                case 'timeCapture': {
                    printQuestion = <TimeCaptureField {...fieldProps} selectedOptions={itemInfo}  paidEmpUsed={paidEmpUsed} />
                }
                break;

                case 'radio': {
                    printQuestion = <RadioBoxFields {...fieldProps} />
                }
                break;

                case 'typeRadio': {
                    printQuestion = <TypeRadioBoxFields {...fieldProps} paidEmpUsed={paidEmpUsed} />
                }
                break;
                

                case 'radioCustomIconLabel': {
                    printQuestion = <RadioCustomIconLabelFields {...fieldProps} />
                }
                break;

                default:
                    printQuestion = <p>No support for this field type: {fieldProps.type}</p>
            }

            return (
                <div className={"sq-form-question " + questionClass} key={qi}>
                    <FieldLabel {...fieldProps} />
                    <div className="sq-form-question-answer">
                        {printQuestion}
                    </div>
                </div>
            )
        });

        return (
            <div className={"add-edit__group " + additionalClass} key={gi}>
                {groupQuestionFields}
            </div>
        )
    })

    return allQuestions;
}

// PropTypes
AddEditWorkExperience.propTypes = {
    item: PropTypes.object,
    itemIndex: PropTypes.number,
    submitForm: PropTypes.func,
    showRemoveButton: PropTypes.func
}
